import styled from 'styled-components';
import { withStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import THEME from '../../constants/theme';

export const StyledDetailsTitle = withStyles({
  root: {
    maxWidth: '90%',
    textOverflow: 'ellipsis',
    wordBreak: 'break-all',
  },
})(Box);

export const StyledButton = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-right: 24px;
  border-radius: 8px;
  &:hover {
    background: ${THEME.greyColors.grey12};
  }
`;
